<script setup lang="ts">
defineProps(['upperFooterData'])
</script>
<template>
  <div class="flex-col lg:flex lg:flex-row lg:px-0 px-[10px]">
    <div
      class="flex lg:my-[0px] my-[80px] md:my-10 justify-between lg:justify-normal md:justify-center"
    >
      <div
        class="flex flex-col md:flex-row lg:flex-col lg:item md:gap-[50px] lg:gap-0 md:relative w-full justify-center"
      >
        <div
          class="flex md:mr-[5px] flex-row-reverse md:flex-row md:justify-center lg:justify-start items-center mr-auto lg:mr-0 lg:flex-row lg:gap-[20px]"
        >
          <div
            class="w-[18px] lg:w-[38px] md:ml-[14px] lg-m-0 ml-3 relative top-[3px] lg:top-[2px] md:top-[2px] md:right-[15px] lg:right-0"
          >
            <img
              :src="upperFooterData?.officelocation_countryimage"
              alt="ofice locations"
              loading="lazy"
            />
          </div>
          <div class="hidden leading-normal lg:text-xl lg:font-bold lg:block 1440:text-nowrap">
            {{ upperFooterData?.officelocation_text }}
          </div>
          <div
            class="block lg:hidden md:text-[16px] md:font-semibold text-[24px] leading-normal font-bold"
          >
            {{ upperFooterData?.officelocation_mobiletext }}
          </div>
        </div>
        <div
          class="lg:pl-[14px] mt-[20px] md:mt-0 lg:mt-[20px] flex flex-col md:flex-row lg:flex-col gap-[25px] md:gap-[50px] lg:gap-[25px] lg:mb-[35px] mb-0 tracking-negative-tightest lg:tracking-normal md:items-center [&>div:last-child]:w-[280px]"
        >
          <div
            v-for="(officeData, index) in upperFooterData?.officelocation_contacts"
            :key="index"
            class="flex lg:gap-[20px] gap-[10px] md:gap-[15px] lg:w-full"
          >
            <div>
              <img :src="officeData.contact_icon" alt="contact icon" loading="lazy" />
            </div>
            <div class="3xl:text-[18px] text-base leading-normal w-full">
              {{ officeData.contact_value }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
